<template>
    <div id="myCustomQuotesForm">
        <div class="table-header border-b">
            <div class="flex flex-wrap w-full">
                <div>
                    <strong>Custom {{ title }} Quotes</strong>
                </div>
                <div class="flex justify-center ml-auto">
                    <a class="btn btn-sm btn-yellow-ghost inline-flex mr-2" :href="getBackLink()">Cancel</a>
                    <div class="btn btn-sm btn-yellow inline-flex " @click="save">Save</div>
                </div>
            </div>
        </div>
        <div class="table-responsive" v-if="items.length > 0">
            <table class="table table-striped table-hover border">
                <thead>
                    <tr>
                        <th class="w-16 text-center">Sort</th>
                        <th>Asset</th>
                        <th class="w-24 text-center">Delete</th>
                    </tr>
                </thead>
                <draggable v-model="items" tag="tbody" handle=".canDrag" item-key="id">
                    <template #item="{ element, index }">
                    <tr>
                        <td class="text-center cursor-move canDrag">
                            <i class="fas fa-arrows-alt text-gray-500"></i>
                        </td>
                        <td v-if="isBlankRow(element)">&nbsp;</td>
                        <td v-else>{{ element.title || element.symbol }}</td>
                        <td class="text-center">
                            <a @click="removeItem(index)" v-tooltip="{ content: 'Delete Symbol', placement: 'auto-start', theme: 'red' }"  class="btn btn-default btn-shadow-none btn-red-ghost btn-xs ml-1 mb-1 md:mb-0" title="Delete Symbol"><i class="fas fa-times"></i></a>
                        </td>
                    </tr>
                    </template>
                </draggable>
                <tfoot>
                    <tr>
                        <th class="text-center">Sort</th>
                        <th>Asset</th>
                        <th class="text-center">Delete</th>
                    </tr>
                </tfoot>
            </table>
        </div>
        <alert-box class="mb-6" v-else>
            <template #body>
                No quotes have been added. Please select one above and click "Add Quote".
            </template>
        </alert-box>
        <div class="flex justify-center mt-4">
            <a class="btn btn-sm btn-yellow-ghost inline-flex mx-1 xs:ml-0" :href="getBackLink()">Cancel</a>
            <div class="btn btn-sm btn-yellow inline-flex mx-1" @click="save">Save</div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import Draggable from 'vuedraggable';

const props = defineProps({
    initialItems: {
        type: Array,
        required: true
    },
    section: String,
    title: String
});

const items = ref(props.initialItems);
const hasChanged = ref(null);

// const hasChanged = computed(() => {
//     return JSON.stringify(props.initialItems) !== JSON.stringify(items.value);
// });

const addItem = (item) => {
    hasChanged.value = true;
    items.value.push(item);
};

const removeItem = (index) => {
    hasChanged.value = true;
    items.value.splice(index, 1);
};

const getBackLink = () => {
    return window.route('my-folder.custom-quotes.index');
};

const handleLeave = (e) => {
    if (hasChanged.value) {
        e.preventDefault();
        e.returnValue = 'Are you sure?';
        return 'Are you sure?';
    }
};

const isBlankRow = (item) => {
    return item.blankRow;
};

const save = () => {
    const route = window.route('my-folder.custom-quotes.batch-update', { section: props.section });

    removeUnloadEvent();

    axios.post(route, { symbols: items.value })
        .then((response) => {
            window.location = getBackLink();
        }).catch((error) => {
        });
};

const removeUnloadEvent = () => {
    window.removeEventListener('beforeunload', handleLeave);
};

onMounted(() => {
    window.addEventListener('beforeunload', handleLeave);
});

onBeforeUnmount(() => {
    removeUnloadEvent();
});

defineExpose({
    addItem
});
</script>

<style lang="scss">
#myCustomQuotesForm {
    @apply border-t-2 border-blue-600 mt-4;
    table {
        thead,
        tfoot {
            td, th {
                @apply px-3 py-2;
            }
        }
        tbody {
            td, th {
                @apply px-3;
            }
        }
        .sortable {
            @apply cursor-pointer;
        }
    }
}
</style>
